import React, { useMemo } from 'react';
import { useAppContext } from '../../context/AppContext';
import { getProductPrice } from '../../utils/pricing';

export default function TopProductsRanking() {
  const { products, sales } = useAppContext();

  const rows = useMemo(() => {
    if (!products.length || !sales.length) return [];

    const map = new Map();

    sales.forEach((s) => {
      const product = products.find((p) => p.id === s.productId);
      if (!product) return;
      const price = getProductPrice(product);
      const current = map.get(product.id) || {
        id: product.id,
        name: product.name,
        qty: 0,
        revenue: 0,
      };
      current.qty += s.quantity;
      current.revenue += price * s.quantity;
      map.set(product.id, current);
    });

    return Array.from(map.values())
      .sort((a, b) => b.qty - a.qty)
      .slice(0, 5);
  }, [products, sales]);

  if (!rows.length) return null;

  const format = (v) => v.toLocaleString('pt-BR', { minimumFractionDigits: 2 });

  return (
    <div className="card shadow-sm mb-4">
      <div className="card-body">
        <h2 className="h6 mb-3">Top 5 produtos (por quantidade)</h2>
        <div className="table-responsive">
          <table className="table table-sm mb-0 align-middle">
            <thead>
              <tr>
                <th>Produto</th>
                <th>Qtd</th>
                <th>Receita (R$)</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{r.name}</td>
                  <td>{r.qty}</td>
                  <td>{format(r.revenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
